<div *ngIf="!isLoginPage" class="support-btn" (click)="onSupportClick()" routerLinkActive="active">
  <img src="assets/images/svg/main-support-icon.svg" alt="Support">
</div>